import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { HeaderLeftAction } from '../../../ui/PageHeader/styled';

export const modalStyles = css`
  border-radius: 7px 7px 0 0;
  height: max-content;
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    align-self: end;
    height: max-content;
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    align-self: center;
    height: 650px;
    width: 1000px;
    max-width: calc(100% - 150px);
  }
`;

export const headerStyles = css`
  @media (min-width: ${Breakpoints.tablet}px) {
    height: 72px;
    padding-left: 30px;

    ${HeaderLeftAction} {
      right: 5px;
    }
  }
`;

export const SliderWrapper = styled.div`
  height: 100%;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide > div {
    height: 100%;
  }
`;
